import { useTheme, useMediaQuery } from "@mui/material";

// Define our breakpoints (in pixels)
export const breakpoints = {
	xs: 0, // Extra small devices (portrait phones)
	sm: 576, // Small devices (landscape phones)
	md: 768, // Medium devices (tablets)
	lg: 992, // Large devices (desktops)
	xl: 1200, // Extra large devices
	xxl: 1400, // Extra extra large devices
};

// Create media query helpers
export const mediaQueries = {
	up: (breakpoint) => `@media (min-width: ${breakpoints[breakpoint]}px)`,
	down: (breakpoint) => `@media (max-width: ${breakpoints[breakpoint] - 0.02}px)`,
	between: (start, end) =>
		`@media (min-width: ${breakpoints[start]}px) and (max-width: ${breakpoints[end] - 0.02}px)`,
};

export const useResponsive = () => {
	const theme = useTheme();

	return {
		isXs: useMediaQuery(theme.breakpoints.only("xs")),
		isSm: useMediaQuery(theme.breakpoints.only("sm")),
		isMd: useMediaQuery(theme.breakpoints.only("md")),
		isLg: useMediaQuery(theme.breakpoints.only("lg")),
		isXl: useMediaQuery(theme.breakpoints.only("xl")),
		isSmDown: useMediaQuery(theme.breakpoints.down("sm")),
		isMdDown: useMediaQuery(theme.breakpoints.down("md")),
		isLgDown: useMediaQuery(theme.breakpoints.down("lg")),
		isSmUp: useMediaQuery(theme.breakpoints.up("sm")),
		isMdUp: useMediaQuery(theme.breakpoints.up("md")),
		isLgUp: useMediaQuery(theme.breakpoints.up("lg")),
	};
};
